import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import React, { memo } from 'react'

const ReferenceSourceField = memo(({ classes, value, handleChange }: any) => {
  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor="refSource-simple">Type</InputLabel>
      <Select
        value={value}
        onChange={handleChange('referenceSource')}
        inputProps={{
          id: 'refSource-simple',
        }}
      >
        <MenuItem value="episodes">episodes</MenuItem>
        <MenuItem value="chapters">chapters</MenuItem>
      </Select>
    </FormControl>
  )
})

export default ReferenceSourceField
